import axios from "axios";
axios.defaults.headers.common["Is-Axios"] = true;
axios.defaults.headers["X-Requested-With"] = "Axios";
import { I18n } from "react-redux-i18n";
import Utilities from "../../../Helpers/Utilities";
import Constants from "../../../AppConstants/Constants";
import { receivedServerError, receivedUnauthorizedError, receivedExpiredSessionError } from "../../Error/Actions";
import { toggleBlockingStatus, updateRequestCount } from "../../Status/Actions";
import { redirectToLoginPage } from "../../Account/Actions";
import {
    RECEIVED_CART,
    TEMP_CART_UPDATED,
    TEMP_CART_KIT_UPDATED,
    TEMP_WIRELESS_PLAN_UPDATED,
    CART_UPDATED,
    CART_CLEARED
} from "../Constants";

export function getCart() {
    return function(dispatch, getState) {
        // dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        // pass a expire param with the date, to make it unique.
        // ie11 caches fetch GET requests and only makes one initial request. this fixes that for ie11 soi it can get cart on page change.
        return fetch(Utilities.buildUrl("/Cart/Get", true), {
            ...Constants.FETCH_REQUEST_CONFIG,
            method: "GET",
            cache: "no-store"
        })
            .then(response => {
                if (!response.ok) {
                    throw response;
                }

                return response.json();
            })
            .then(data => {
                dispatch(receivedServerError(false));
                dispatch(receivedCart(data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.status === 401 || error.status === 403) {
                    dispatch(redirectToLoginPage());
                } else if (error.redirect) {
                    window.location.href = error.url;
                } else {
                    const errorText = error.clone();
                    if (typeof error.json === "function") {
                        error.json()
                            .then(json => {
                                dispatch(receivedServerError(true, json.value));
                                dispatch(receivedServerError(false));

                                if (getState().requestCount === 0) {
                                    dispatch(toggleBlockingStatus(false));
                                }
                            })
                            .catch(err => {
                                if (typeof errorText.text === "function") {
                                    errorText.text()
                                        .then(text => {
                                            dispatch(receivedServerError(true, text));
                                            dispatch(receivedServerError(false));

                                            if (getState().requestCount === 0) {
                                                dispatch(toggleBlockingStatus(false));
                                            }
                                        })
                                        .catch(err => {
                                            dispatch(receivedServerError(true, I18n.t("alerts.genericError")));
                                            dispatch(receivedServerError(false));

                                            if (getState().requestCount === 0) {
                                                dispatch(toggleBlockingStatus(false));
                                            }
                                        });
                                }
                            });
                    }
                }
            });
    };
}

function receivedCart(data) {
    return {
        type: RECEIVED_CART,
        payload: data
    };
}

export function addToCart(item, showLoadingStatus, cb) {
    return function(dispatch, getState) {
        if (showLoadingStatus) {
            dispatch(toggleBlockingStatus(true));
        }

        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Cart/Add"), Utilities.serializeJson(item), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(cartUpdated(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

export function subscribeToBackInStock(item, cb) {
    return function (dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Cart/NotifyUserWhenAvailable"), Utilities.serializeJson(item), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

export function updateTempCart(item) {
    return {
        type: TEMP_CART_UPDATED,
        payload: item
    };
}

export function updateTempCartKitUI(item) {
    return {
        type: TEMP_CART_KIT_UPDATED,
        payload: item
    };
}

export function updateTempWirelessPlan(item) {
    return {
        type: TEMP_WIRELESS_PLAN_UPDATED,
        payload: item
    }
}

export function removeFromCart(item) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.put(Utilities.buildUrl("/Cart/Remove"), Utilities.serializeJson(item), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(cartUpdated(res.data));
                dispatch(toggleBlockingStatus(false));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

export function updateCartItem(item) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.put(Utilities.buildUrl("/Cart/Update"), Utilities.serializeJson(item), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(cartUpdated(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function cartUpdated(data) {
    return {
        type: CART_UPDATED,
        payload: data
    };
}

export function clearCart(token) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.put(Utilities.buildUrl("/Cart/Clear"), Utilities.serializeJson(token), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(cartCleared(res));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function cartCleared() {
    return {
        type: CART_CLEARED
    };
}